<template>
  <div class="page-footer">
    <div class="container">
      <p class="footer-info">
        &copy;2022 rencaimatou.com
        <a class="beian-link" href="https://beian.miit.gov.cn" target="_blank"
          >京ICP备17070664号-3</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.page-footer {
  text-align: center;
  height: 64px;
  line-height: 64px;

  .footer-info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
  }

  .beian-link {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.65);

    &.hover {
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
